import React from 'react';
import { X } from 'lucide-react';
import Button from './Button';

interface CloseButtonProps {
  onClick: () => void;
  className?: string;
  'aria-label'?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, className = '', 'aria-label': ariaLabel }) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className={`p-1 hover:bg-gray-100 rounded-full ${className}`}
      aria-label={ariaLabel}
    >
      <X className="w-5 h-5" />
    </Button>
  );
};

export default CloseButton;
